import React from 'react'
import Drawer from '@mui/material/Drawer';
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import Button from "@mui/material/Button"
import SeekerProfile from '../OffCanvas/Profile/SeekerProfile';
import BabySitter from '../OffCanvas/Profile/BabySitter';
import HouseKepper from '../OffCanvas/Profile/HouseKeeper';
import { Edit, Delete, CheckCircle } from "@mui/icons-material"
import { Seeker as EditSeeker } from '../OffCanvas/EditProfile/Seeker';
import { HouseKeeper as EditHouseKeeper } from '../OffCanvas/EditProfile/HouseKeeper';
import { BabySitter as EditBabySitter } from '../OffCanvas/EditProfile/BabySitter';
import mainContext from '../../contexts/mainContext'

const anchor = "right"; //DIRECTION FRO WHERE DRAWER WILL OPEN

const UserCard = ({
  state, userId, city, status, email, name, mobile, added,
  openCanvasOf, onUpdate, onDelete, paypal, stripe, type = null, userInfo, autoOpen = false
}) => {
  const [open, setOpen] = React.useState(false)
  const [editProfile, setEditProfile] = React.useState(false)
  const [deleteConfirmOpen, setDeleteConfirmOpen] = React.useState(false)
  const { loginUserDetails } = React.useContext(mainContext)

  React.useEffect(() => {
    if (autoOpen) setOpen(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoOpen])

  const handleClose = () => {
    setEditProfile(false)
    setOpen(false)
  }

  const handleDeleteClick = () => setDeleteConfirmOpen(true)
  const handleDeleteConfirm = () => {
    setDeleteConfirmOpen(false)
    onDelete?.(userId)
  }
  const handleDeleteCancel = () => setDeleteConfirmOpen(false)

  return (
    <>
      <Drawer anchor={anchor} open={open} onClose={handleClose}>
        {openCanvasOf === "seeker" && (
          editProfile
            ? <EditSeeker setOpen={handleClose} userId={userId} cb={onUpdate} />
            : <SeekerProfile open={open} setOpen={setOpen} userId={userId} state={state} />
        )}
        {openCanvasOf === "house-keeper" && (
          editProfile
            ? <EditHouseKeeper setOpen={handleClose} userId={userId} cb={onUpdate} />
            : <HouseKepper open={open} setOpen={handleClose} userId={userId} state={state} />
        )}
        {openCanvasOf === "baby-sitter" && (
          editProfile
            ? <EditBabySitter setOpen={handleClose} userId={userId} cb={onUpdate} />
            : <BabySitter open={open} setOpen={handleClose} userId={userId} state={state} />
        )}
      </Drawer>

      <Dialog
        open={deleteConfirmOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to permanently delete this user? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">Cancel</Button>
          <Button onClick={handleDeleteConfirm} color="error" variant="contained">Delete</Button>
        </DialogActions>
      </Dialog>

      <div className={`list_card ${type === "provider" ? "Users_list_grid" : "customer_list_grid"}`}>
        <div>
          <div className={
            status === "Active" ? "list_card_status status_active"
              : status === "Inactive" ? "list_card_status status_inactive"
              : "list_card_status status_sleeping"
          }>
            {status || "Inactive"}
          </div>
        </div>
        <div>
          {name}
          {userInfo?.isIdVerifiedBadge && (
            <CheckCircle
              titleAccess="ID Verified"
              sx={{ fontSize: 16, marginLeft: '6px', verticalAlign: 'text-bottom', color: 'var(--nona-theme-color)' }}
            />
          )}
        </div>
        <div>{email}</div>
        <div>{mobile}</div>
        <div>{city}</div>
        {type === "provider" && (
            <div>
              {(() => {
                // Decide condition for "Fully Onboarded"
                const isFullyOnboarded = userInfo?.isProfileCompleted && userInfo?.isJobProfileCompleted && (stripe || paypal);
                
                if (isFullyOnboarded) {
                  return "Fully Onboarded";
                }

                const providers = [];
                if (stripe) providers.push("Stripe");
                if (paypal) providers.push("Paypal");
                
                return providers.length > 0 ? providers.join(", ") : "---";
              })()}
            </div>
        )}
        <div style={{ textAlign: "right" }}>{added}</div>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          {loginUserDetails.role !== "Concierge" && (
            <>
              <Edit className="pointer" sx={{ marginRight: 1 }} onClick={() => { setEditProfile(true); setOpen(true) }} />
              <Delete className="pointer" sx={{ marginRight: 1, color: "#f44336" }} onClick={handleDeleteClick} />
            </>
          )}
          <button className="list_card_view_btn" onClick={() => setOpen(true)}>View</button>
        </div>
      </div>
    </>
  )
}

export default UserCard